import { useDeskMode } from "@/lib/mode";
import { TradeDesk } from "../TradeDesk";
import { SimpleDesk } from "./SimpleDesk";

/** "/" shows the beginner Simple desk or the Pro terminal, per the rail switch. */
export function DeskPage() {
	const [mode] = useDeskMode();
	return mode === "pro" ? <TradeDesk /> : <SimpleDesk />;
}
